import * as ambassadorWixFunctionsV1Function from './functions-v1-function-functions.http.js';
import * as ambassadorWixFunctionsV1FunctionTypes from './functions-v1-function-functions.types.js';
import * as ambassadorWixFunctionsV1FunctionUniversalTypes from './functions-v1-function-functions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createFunction(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFunctionsV1FunctionUniversalTypes.CreateFunctionRequest,
  ambassadorWixFunctionsV1FunctionTypes.CreateFunctionRequest,
  ambassadorWixFunctionsV1FunctionUniversalTypes.CreateFunctionResponse,
  ambassadorWixFunctionsV1FunctionTypes.CreateFunctionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFunctionsV1Function.createFunction(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/functions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getFunction(): __PublicMethodMetaInfo<
  'GET',
  { functionId: string },
  ambassadorWixFunctionsV1FunctionUniversalTypes.GetFunctionRequest,
  ambassadorWixFunctionsV1FunctionTypes.GetFunctionRequest,
  ambassadorWixFunctionsV1FunctionUniversalTypes.GetFunctionResponse,
  ambassadorWixFunctionsV1FunctionTypes.GetFunctionResponse
> {
  const payload = { functionId: ':functionId' } as any;

  const getRequestOptions =
    ambassadorWixFunctionsV1Function.getFunction(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/functions/{functionId}',
    pathParams: { functionId: 'functionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateFunction(): __PublicMethodMetaInfo<
  'PATCH',
  { functionId: string },
  ambassadorWixFunctionsV1FunctionUniversalTypes.UpdateFunctionRequest,
  ambassadorWixFunctionsV1FunctionTypes.UpdateFunctionRequest,
  ambassadorWixFunctionsV1FunctionUniversalTypes.UpdateFunctionResponse,
  ambassadorWixFunctionsV1FunctionTypes.UpdateFunctionResponse
> {
  const payload = { function: { id: ':functionId' } } as any;

  const getRequestOptions =
    ambassadorWixFunctionsV1Function.updateFunction(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/functions/{function.id}',
    pathParams: { functionId: 'functionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteFunction(): __PublicMethodMetaInfo<
  'DELETE',
  { functionId: string },
  ambassadorWixFunctionsV1FunctionUniversalTypes.DeleteFunctionRequest,
  ambassadorWixFunctionsV1FunctionTypes.DeleteFunctionRequest,
  ambassadorWixFunctionsV1FunctionUniversalTypes.DeleteFunctionResponse,
  ambassadorWixFunctionsV1FunctionTypes.DeleteFunctionResponse
> {
  const payload = { functionId: ':functionId' } as any;

  const getRequestOptions =
    ambassadorWixFunctionsV1Function.deleteFunction(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/functions/{functionId}',
    pathParams: { functionId: 'functionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryFunctions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixFunctionsV1FunctionUniversalTypes.QueryFunctionsRequest,
  ambassadorWixFunctionsV1FunctionTypes.QueryFunctionsRequest,
  ambassadorWixFunctionsV1FunctionUniversalTypes.QueryFunctionsResponse,
  ambassadorWixFunctionsV1FunctionTypes.QueryFunctionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFunctionsV1Function.queryFunctions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/functions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateFunctionTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFunctionsV1FunctionUniversalTypes.BulkUpdateFunctionTagsRequest,
  ambassadorWixFunctionsV1FunctionTypes.BulkUpdateFunctionTagsRequest,
  ambassadorWixFunctionsV1FunctionUniversalTypes.BulkUpdateFunctionTagsResponse,
  ambassadorWixFunctionsV1FunctionTypes.BulkUpdateFunctionTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFunctionsV1Function.bulkUpdateFunctionTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/functions/bulk-update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateFunctionTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFunctionsV1FunctionUniversalTypes.BulkUpdateFunctionTagsByFilterRequest,
  ambassadorWixFunctionsV1FunctionTypes.BulkUpdateFunctionTagsByFilterRequest,
  ambassadorWixFunctionsV1FunctionUniversalTypes.BulkUpdateFunctionTagsByFilterResponse,
  ambassadorWixFunctionsV1FunctionTypes.BulkUpdateFunctionTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFunctionsV1Function.bulkUpdateFunctionTagsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/functions/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  _Function as _FunctionOriginal,
  ActivationStatus as ActivationStatusOriginal,
  ActivationStatusWithLiterals as ActivationStatusWithLiteralsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  DraftDiscarded as DraftDiscardedOriginal,
  TagsModified as TagsModifiedOriginal,
  CreateFunctionRequest as CreateFunctionRequestOriginal,
  CreateFunctionResponse as CreateFunctionResponseOriginal,
  GetFunctionRequest as GetFunctionRequestOriginal,
  GetFunctionResponse as GetFunctionResponseOriginal,
  UpdateFunctionRequest as UpdateFunctionRequestOriginal,
  UpdateFunctionResponse as UpdateFunctionResponseOriginal,
  DeleteFunctionRequest as DeleteFunctionRequestOriginal,
  DeleteFunctionResponse as DeleteFunctionResponseOriginal,
  QueryFunctionsRequest as QueryFunctionsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryFunctionsResponse as QueryFunctionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  ListValuesByFieldRequest as ListValuesByFieldRequestOriginal,
  ListValuesByFieldResponse as ListValuesByFieldResponseOriginal,
  FieldAndCount as FieldAndCountOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  UpdateFunctionExternalIdsRequest as UpdateFunctionExternalIdsRequestOriginal,
  UpdateFunctionExternalIdsResponse as UpdateFunctionExternalIdsResponseOriginal,
  BulkUpdateFunctionTagsRequest as BulkUpdateFunctionTagsRequestOriginal,
  BulkUpdateFunctionTagsResponse as BulkUpdateFunctionTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateFunctionTagsResult as BulkUpdateFunctionTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateFunctionTagsByFilterRequest as BulkUpdateFunctionTagsByFilterRequestOriginal,
  BulkUpdateFunctionTagsByFilterResponse as BulkUpdateFunctionTagsByFilterResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateFunctionTagsApplicationErrors as BulkUpdateFunctionTagsApplicationErrorsOriginal,
  BulkUpdateFunctionTagsByFilterApplicationErrors as BulkUpdateFunctionTagsByFilterApplicationErrorsOriginal,
} from './functions-v1-function-functions.types.js';
